import { FeatureCollection } from 'geojson'
import clone from '@turf/clone'
import { point } from '@turf/helpers'

/**
 * Repairs LineStrings with single coordinates by converting them to Points.
 *
 * @param geoJson - The GeoJSON FeatureCollection to repair
 * @returns A new FeatureCollection with single-coordinate LineStrings converted to Points
 */
export const repairSingleCoordinateLineStringsIssue = (
  geoJson: FeatureCollection<any>,
): FeatureCollection<any> => {
  const repairedGeoJson = clone(geoJson)

  repairedGeoJson.features.forEach((feature) => {
    if (
      feature.geometry?.type === 'LineString' &&
      feature.geometry.coordinates.length === 1
    ) {
      // Convert single-coordinate LineString to Point
      feature.geometry = point(feature.geometry.coordinates[0]).geometry
    }
  })

  return repairedGeoJson
}
